import { generatePath } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { DESIGN_PATH, DOC_PATH } from 'paths'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { KeyActionButton } from './KeyActionButton'

export interface EndReviewButtonProps {
  request: InformalFeedbackRequest
}

export const EndReviewButton = ({ request }: EndReviewButtonProps) => {
  const history = useHistory()

  const handlePress = () => {
    if (request.article) {
      history.push({
        pathname: generatePath(DOC_PATH, { slug: request.article.slug }),
        search: 'endRequest=true',
      })
    } else {
      history.push({
        pathname: generatePath(DESIGN_PATH, { key: request.design.key }),
        search: 'endRequest=true',
      })
    }
  }

  return <KeyActionButton reviewType={request.type} label={'End Review'} onPress={handlePress} />
}
